<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 v-for="(test, index) in testimonials" :key="index" pr-2 class="testimonial mb-3">
                <v-card>
                    <v-card-text>
                        <h2 class="success--text">{{ test.name }}</h2>
                        <h3>{{ test.phone }}</h3>
                        <div v-html="test.text"></div>                        
                    </v-card-text>
                </v-card>

                <div class="bottom-line">&nbsp;</div>
            </v-flex>           
        </v-layout>
        <!--<v-layout>
            <v-flex xs12 sm6 v-for="(test, index) in testimonials" :key="index" pr-2>
                <h2 class="success--text">{{ test.name }}</h2>
                <h3>{{ test.phone }}</h3>
                <div v-html="test.text"></div>
                <hr>
            </v-flex>           
        </v-layout> -->
    </div>
</template>

<script>
    export default {
        props: ['testimonials'],
        data: () => ({
           
        })
    }
</script>

<style>
    .bottom-line {
        border-bottom: 1px dashed #c0c0c0;
    }
</style>

